import moment from 'moment-timezone';

const NEEDS_QUOTES = /[",\r\n]/;

const escapeValue = (value) => {
  if (value === null || value === undefined) {
    return '';
  }
  const text = String(value);
  return NEEDS_QUOTES.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

// Same rule material-table applies in m-table-toolbar's getTableData
export const getExportableColumns = (columns) =>
  columns
    .filter((column) => (!column.hidden || column.export === true) && column.export !== false && column.field)
    .sort((a, b) => {
      const orderA = a.tableData ? a.tableData.columnOrder : 0;
      const orderB = b.tableData ? b.tableData.columnOrder : 0;
      return orderA > orderB ? 1 : -1;
    });

export const buildCsvRows = (columns, data) =>
  data.map((rowData) =>
    columns.map((column) => {
      const value = rowData[column.field];
      if (value === null || value === undefined || value === '') {
        return '';
      }
      return column.exportTransform ? column.exportTransform(rowData) : value;
    }));

export const buildCsvFileName = (teamName, title) =>
  [teamName, title, moment().format('YYYY-MM-DD_HH_mm_ss')]
    .filter(Boolean)
    .join(' ')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');

export const toCsvContent = (headers, rows) =>
  [headers, ...rows].map((row) => row.map(escapeValue).join(',')).join('\r\n');

export const downloadCsv = (fileName, headers, rows) => {
  const content = toCsvContent(headers, rows);
  // the BOM keeps Excel on Windows from reading the file as ANSI
  const blob = new Blob(['\uFEFF', content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const exportColumnsToCsv = (teamName, title, columns, data) => {
  const exportable = getExportableColumns(columns);
  downloadCsv(
    buildCsvFileName(teamName, title),
    exportable.map((column) => column.title),
    buildCsvRows(exportable, data)
  );
};
